"use client";

import { ProjectSections } from "@/components/projects/project-sections";
import { getProjectDataCached, ProjectPageData } from "@/utils/get-project-data";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
import { useEffect, useState } from "react";
interface ProjectSectionWrapperProps {
  projectId: string;
}
export function ProjectSectionWrapper({
  projectId
}: ProjectSectionWrapperProps) {
  const [projectData, setProjectData] = useState<ProjectPageData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let isMounted = true;
    const fetchProjectData = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await getProjectDataCached(projectId);
        if (!isMounted) return;
        if ("error" in result) {
          setError(result.error);
        } else {
          setProjectData(result);
        }
      } catch (err) {
        if (!isMounted) return;
        setError(err instanceof Error ? err.message : "Failed to load project data");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    fetchProjectData();
    return () => {
      isMounted = false;
    };
  }, [projectId]);
  if (loading) {
    return <div className="flex items-center justify-center p-8">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
			</div>;
  }
  if (error) {
    return <div className="text-red-500 p-4">Error loading project data: {error}</div>;
  }
  if (!projectData) {
    return <div className="text-gray-500 p-4">No project data available</div>;
  }
  const coordinates = projectData.gps;
  const nearByProjects = projectData.nearByProjects || [];
  const categories = projectData.images.filter(cat => Boolean(cat.space)).map(({
    space
  }) => ({
    name: toSentenceCase(space),
    code: space
  })).reduce((acc: {
    name: string;
    code: string;
  }[], curr: {
    name: string;
    code: string;
  }) => {
    if (!acc.some(cat_0 => cat_0.code === curr.code)) {
      acc.push(curr);
    }
    return acc;
  }, []);
  return <ProjectSections projectData={projectData} coordinates={coordinates} nearByProjects={nearByProjects} id={projectId} categories={categories} />;
}